'use client';

import cx from 'classnames';

import { PrismicImageWithThumbnail } from '../../../../../core/Api/Prismic/Resources/image';
import { PrismicWebLink } from '../../../../../core/Api/Prismic/Resources/link';
import { ampli } from '../../../../../core/Tracking/Amplitude/__AUTO_GENERATED__';
import {
    TrackingProperties,
    useTrackEventAmplitude,
} from '../../../../../core/Tracking/Amplitude/Amplitude';
import { Typography } from '../../../../../design-system/components/typography/Typography';

import style from './ThematicCard.module.css';

export function ThematicCard({
    title,
    description,
    link,
    image,
    isHovered,
    onMouseEnter,
    trackingInformation,
}: {
    title: string;
    description: string;
    link: PrismicWebLink;
    image: PrismicImageWithThumbnail<'card_cover' | 'card_cover_retina'>;
    isHovered: boolean;
    onMouseEnter: () => void;
    trackingInformation: {
        click: Omit<TrackingProperties<typeof ampli.marketingThematicClicked>, 'url_redirection'>;
    };
}) {
    const { trackEvent } = useTrackEventAmplitude();

    return (
        <div
            className={cx(style.card, {
                [style.cardHovered]: isHovered,
            })}
            onMouseEnter={() => {
                onMouseEnter();
            }}
        >
            <div className={style.imageWrapper}>
                <img
                    alt={image.alt}
                    className={style.image}
                    src={image.card_cover.url}
                    srcSet={`${image.card_cover_retina.url} 2x`}
                    sizes="(min-width: 992px) 280px, 240px"
                    loading="lazy"
                />
            </div>
            <div className={style.content}>
                <Typography
                    as="a"
                    href={link.url}
                    scale="primary-s-extra-bold"
                    className={style.title}
                    onClick={() => {
                        trackEvent((ampli, defaultProperties) => {
                            ampli.marketingThematicClicked({
                                ...defaultProperties,
                                ...trackingInformation.click,
                                url_redirection: link.url,
                            });
                        });
                    }}
                >
                    {title}
                </Typography>
                <Typography className={style.description} as="div" scale="primary-body-regular">
                    {description}
                </Typography>
            </div>
        </div>
    );
}
